import AdminNavBar from './AdminNavBar'
import NavDropdown from 'react-bootstrap/NavDropdown';
import { Link, navigate, useNavigate } from 'react-router-dom';
import { Card, Col, Container, Dropdown, Nav, Navbar, Row } from 'react-bootstrap';
import logo1 from '../Assets/logonew.png'
import React, { useState, useEffect } from "react";
import "../Admin/AdminMaster/AdminBilling.css";
import './Master.css'
import { Button, Form,  Modal, Spinner,  Table } from 'react-bootstrap'
import axios from 'axios'
import { toast } from 'react-toastify'
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch, { SwitchProps } from '@mui/material/Switch';
import Stack from '@mui/material/Stack';
import { Switch as AntSwitch, Rate } from 'antd';
import Typography from '@mui/material/Typography';
import { ProductAdd, ProductDelete, ProductFindAll, ProductUpdate } from '../Admin/API/Api';
import NavLogo from './NavLogo';
import { MDBDataTable } from 'mdbreact';
import { TextField } from '@mui/material';

const ProductMaster1 = () => {

  const userdata = JSON.parse(sessionStorage.getItem('userdata'));
  const branchId = userdata.branch_id;
  const Name = userdata ? userdata.branch_name : '';

  const [status, setStatus] = useState(true);// State to track the switch status
  const [show, setShow] = useState(false);
  const [productName, setProductName] = useState();
  const [rate, setRate] = useState();
  const [data, setData] = useState([]);
  const [isEditing, setisEditing] = useState(false);
  const [productId, setProductId] = useState();
  const [loading, setLoading] = useState(false);
  const selectedLanguage = sessionStorage.getItem('selectedLanguage');
  

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [showEdit, setShowEdit] = useState(false);


  // =========== delete modal =========
 const [show1, setShow1] = useState(false);
 const handleClose1 = () => setShow1(false);

 const [itemToDelete, setItemToDelete] = useState(null);

 const handleShow1 = (item) => {
   setItemToDelete(item);
   setShow1(true);
 };  

//  =========== Edit ======
  const handleEditClose = () => {
    setShowEdit(false);
    setProductId('');
    setProductName('');
    setRate('');
    setStatus(false); 
  };

  const handleEditShow = (item) => {
    setProductId(item.product_id);
    setProductName(item.product_name);
    setRate(item.rate);
    setRate(item.rate);
    setStatus(item.status === 1 ? true : false);
    setShowEdit(true);
  };


 // Function to fetch data from the backend
const fetchData = () => {
  axios
    .get(`${ProductFindAll}/${branchId}`)
    .then((res) => {
      console.log("Data fetched successfully:", res.data);
      setData(res.data);
    })
    .catch((err) => {
      console.error("Failed to fetch data:", err);
      toast.error("Failed to fetch data. Please try again.", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    });
};

// Function to save data
const saveData = (e) => {
  e.preventDefault();
  setLoading(true);

  // Send the status to the backend (1 for ON, 2 for OFF)
  const backendValue = status ? 1 : 2;
  // Add your logic to send the value to the backend
  console.log('Sending value to backend:', backendValue);
  handleClose(); // Close the modal after submitting

  if (!productName || !rate) {
    alert("All fields are required");
    setLoading(false);
    return;
  }

  const formData = {
    product_name: productName,
    rate: rate,
    status: backendValue,
    branch_id: branchId
  };

  console.log("FormData:", formData);

  axios
    .post(ProductAdd, formData)
    .then((res) => {
      console.log("res...",res);
      if (res.data.message === "SAVED") {
        console.log("Data saved successfully:", res.data);
        toast.success("Data Saved Successfully!", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });

        setProductName('');
        setStatus('');
        setRate('');
        fetchData(); // Refresh data after saving
        setLoading(false);
      }
    })
    .catch((err) => {
      console.error("Failed to save data:", err);
      toast.error("Failed to save data. Please try again.", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    });
};


// Function to update data
const updateProduct = () => {
  if (!productName || !rate) {
    alert("All fields are required");
    setLoading(false);
    return;
  }

  const formData = {
    product_name: productName,
    rate: rate,
    status: status,
  };

  console.log("FormData:", formData);

  axios
    .put(`${ProductUpdate}${productId}`, formData)
    .then((res) => {
      if (res.data === "UPDATE") {
        console.log("Data updated successfully:", res.data);
        toast.success("Data Updated Successfully!", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
        fetchData(); // Refresh data after updating
        handleEditClose();
      }
    })
    .catch((err) => {
      console.error("Failed to update data:", err);
      toast.error("Failed to update data. Please try again.", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    });
};

let isProductFetched = false
useEffect(() => {
  if (isProductFetched) return
  fetchData(); // Fetch initial data on component mount
  isProductFetched = true
}, []);

    //delete data
    const onDelete = (item) => {
      console.log("Deleting item:", item);
      axios  
        .delete(`${ProductDelete}${item.product_id}`)
        .then((res) => {
          console.log("Delete response:", res.data);
          if (res.data === "DELETE") {
            // alert("File Deleted Succesfully");
            toast.success("Data Deleted Succesfuly!", {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
            });
          }
          handleClose1(false)
          fetchData();
        })
        .catch((err) => {
          // alert("Failed to upload, try again");
          console.log("Error deleting item:", err);
          toast.error("Failed to upload, try again", {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          });
          console.log(err);
        });
    };

  const handleSwitchChange = () => {
    setStatus(!status); // Toggle the switch status
  };

  const columns = [
    { label: (selectedLanguage === 'Marathi' ? 'अनु.क्र.' : 'Sr.No'), field: 'srNo', sort: 'asc' },
    { label: (selectedLanguage === 'Marathi' ? 'उत्पादनाचे नांव' : 'Product Name'), field: 'productName', sort: 'asc' },
    { label: (selectedLanguage === 'Marathi' ? 'उत्पादन स्थिती' : 'Product Status'), field: 'status', sort: 'asc' },
    { label: (selectedLanguage === 'Marathi' ? 'दर' : 'Rate'), field: 'rate', sort: 'asc' },
    { label: (selectedLanguage === 'Marathi' ? 'सुधारणे' : 'Edit'), field: 'edit', sort: 'asc' },
    { label: (selectedLanguage === 'Marathi' ? 'हटवा' : 'Delete'), field: 'delete', sort: 'asc' }
  ];

  const rows = data.map((item, index) => ({
    srNo: index + 1,
    productName: item.product_name,
    status: item.status === 1 ? (selectedLanguage === 'Marathi' ? 'चालू' : 'Active') : (selectedLanguage === 'Marathi' ? 'बंद' : 'Inactive'),
    rate: item.rate,
    edit: (
      <button className='m-1' style={{ color: "rgb(255, 93, 0)", border: "0px", backgroundColor: "transparent" }}
        onClick={() => handleEditShow(item)}
      >
        <i className="fa-solid fa-pen-to-square"></i>
      </button>
    ),
    delete: (
      <button className='m-1' style={{ color: "red", border: "0px", backgroundColor: "transparent" }}
        onClick={() => handleShow1(item)}
      >
        <i className="fa-solid fa-trash"></i>
      </button>
    )
  }));
  return (
    <div>
    <AdminNavBar />
       <section className="home-section">

       <NavLogo />

    <Row className="m-0 p-0 pt-5 px-md-4 px-2">
        <Col className=' rounded text-center pt-2'
          style={{
            display: "flex",
            justifyContent: "start",
            backgroundColor:"white",
            border:"0px",
            alignItems: "center",
            alignContent:"center",
            color: " rgb(47, 79, 79)",
          }}
        >
          <h5>
           {selectedLanguage === 'Marathi' ? 'उत्पादन मास्टर' : 'PRODUCT MASTER'}
          </h5>
        </Col>
      </Row>

{/* ========================== Product Master =========================== */}

   <Row className='BgImg  m-0 p-0' style={{backgroundColor:"rgb(214, 234, 248)"}}>

   {/* ====================== table =============== */}
   <Row className='m-0 p-0  px-md-3  py-1 mb-5  w-100' style={{display:"flex"}}>
 
   <Row className="m-0 p-0 pt-3 px-2 ">
        <Col className=' rounded text-center py-2'
          style={{
            display: "flex",
            justifyContent: "start",
            backgroundColor:"white",
            border:"0px",
            alignItems: "center",
            alignContent:"center",
            color: " rgb(47, 79, 79)",
          }}
        ><button className='p-1 px-3' onClick={handleShow}  style={{backgroundColor:"rgb(214, 234, 248)",color:"rgb(47, 79, 79)"}}><b > + ADD </b></button>
        </Col>
      </Row>

      {/* <Row className="m-0 p-0 pt-3 px-2  rounded">
      <Col className="m-0 p-0  px-3 rounded" style={{background:"white"}} >
   <div style={{ overflowY: 'auto'}}>
  <div style={{ overflowX: 'auto' }}>
     <Table striped bordered hover size="sm" className='rounded mb-3 mt-3' style={{textAlign:"center",border:"1px solid rgb(198, 204, 209)"}}>
         <thead >
             <tr > 
                 <th style={{alignItems:"center", backgroundColor:"rgb(47, 79, 79)",fontSize:"13px",fontFamily:"sans-serif"}} className='text-center text-light'>Sr.No</th>
                 <th style={{alignItems:"center", backgroundColor:"rgb(47, 79, 79)",fontSize:"13px",fontFamily:"sans-serif"}} className='text-center text-light'>Product Name</th>
                 <th style={{alignItems:"center", backgroundColor:"rgb(47, 79, 79)",fontSize:"13px",fontFamily:"sans-serif"}} className='text-center text-light'>Product Status</th>
                 <th style={{alignItems:"center", backgroundColor:"rgb(47, 79, 79)",fontSize:"13px",fontFamily:"sans-serif"}} className='text-center text-light'>Edit</th>
                 <th style={{alignItems:"center", backgroundColor:"rgb(47, 79, 79)",fontSize:"13px",fontFamily:"sans-serif"}} className='text-center text-light'>Delete</th>
             </tr>
         </thead>
         <tbody>
           {data.map((item,index)=>{
             return(               
             <tr className='border' style={{fontSize:"14px"}}>
                 <td style={{ textAlign:"center"}}>{index+1}</td>
                 <td style={{ textAlign:"center"}}>{item.product_name}</td>
                 <td style={{ textAlign:"center"}}>
                 {item.status === 1 ? "Active" : "InActive"}
                 </td>
                 <td style={{textAlign:"center"}}>
                <button className=' m-1' style={{color:"rgb(255, 93, 0)",border:"0px", backgroundColor:"transparent"}}
                  onClick={() => handleEditShow(item)}
                ><i class="fa-solid fa-pen-to-square"></i></button></td>
                <td style={{textAlign:"center"}}>
                <button className=' m-1' style={{color:"red",border:"0px", backgroundColor:"transparent"}}
                
                onClick={() => handleShow1(item)}
                 ><i className="fa-solid fa-trash"></i></button></td>
             </tr>
              )
             })} 
         </tbody>
     </Table>
     </div>
     </div>
     </Col>
   </Row> */}

   <Row className="m-0 p-0 pt-3 px-2 rounded">
      <Col className="m-0 p-0 px-3 py-3 rounded" style={{ background: "white" }}>
        <MDBDataTable
          striped
          className='custom-datatable'
          bordered
          hover
          data={{ columns, rows }}
        />
      </Col>
    </Row>

   </Row>


   {/* ========================== Modal ============= */}
   {show && !showEdit && ( // Check if 'show' is true and 'showEdit' is false
        <Modal className='shadow rounded' show={show} onHide={handleClose}>
          <Modal.Header className='m-0 p-0 ps-3 text-center' style={{ backgroundColor: "rgb(47, 79, 79)", color: "black" }}>
            <Modal.Title >
              <p style={{ fontSize: "18px" }} className='text-center mt-2 text-light'>{selectedLanguage === 'Marathi' ? 'उत्पादन मास्टर' : 'PRODUCT MASTER'}</p>
            </Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <Row className='m-0'>

              <Row className='mt-3' style={{ display: "flex" }}>
                <Col sm={4} md={5}>
                  <Form.Label><h6 >{selectedLanguage === 'Marathi' ? 'उत्पादनाचे नांव :' : 'Product Name :'}</h6></Form.Label>
                </Col>
                <Col sm={8} md={7}>
                  <Form.Control
                    aria-label="Default select example"
                    onChange={(e) => setProductName(e.target.value)}
                    value={productName}
                    maxLength={40}
                    required
                  >
                  </Form.Control>
                </Col>
              </Row>

              <Row sm={12} md={12} className='mt-3' style={{ display: "flex" }}>
                <Col sm={4} md={5}>
                  <Form.Label><h6>{selectedLanguage === 'Marathi' ? 'स्थिती' : 'Status'} :</h6></Form.Label>
                </Col>
                <Col sm={8} md={7}>
                  <FormGroup>
                    <Stack direction="row" spacing={1} alignItems="center">
                      <Typography>{selectedLanguage === 'Marathi' ? 'बंद' : 'Off'} </Typography>
                      <AntSwitch
                        checked={status}
                        onChange={handleSwitchChange}
                        inputProps={{ 'aria-label': 'ant design' }}
                      />
                      <Typography>{selectedLanguage === 'Marathi' ? 'चालू' : 'On'} </Typography>
                    </Stack>
                  </FormGroup>
                </Col>
              </Row>

              <Row className='mt-3' style={{ display: "flex" }}>
           
                <Col sm={4} md={5}>
                  <Form.Label><h6 ><b>{selectedLanguage === 'Marathi' ? 'दर' : 'Rate'}:</b></h6></Form.Label>
                  </Col>
                  <Col sm={8} md={7}>
                  <TextField
                    size="small"
                    style={{ width: '100%' }}
                    type="number"
                    pattern="[0-9]"
                    required
                    value={rate}
                    onChange={(e) => setRate(e.target.value)}
                  />
                </Col>
              </Row>
            </Row>
            <Form
            //  onSubmit={savedata}
              encType="multipart/form-data">


            </Form>
          </Modal.Body>

          <Modal.Footer className='m-0 p-0' style={{ backgroundColor: "rgb(47, 79, 79)" }}>
            <Button style={{ color: "black", backgroundColor: "white",border:"0px",  borderRadius: "15px" }} onClick={handleClose}>
              {selectedLanguage === 'Marathi' ? 'रद्द करा' : 'Cancel'} 
            </Button>

            {
              isEditing === false ?
                <Button style={{ border: "0px", backgroundColor: "rgb(135, 178, 178)", borderRadius: "15px" }} className='buttonAll py-2 px-3 mx-2  shadow text-dark' type='submit' onClick={saveData} disabled={loading}>
                  {loading ? <Spinner animation='border' size='sm' variant="primary" /> : <div>{selectedLanguage === 'Marathi' ? 'जतन करा' : 'Save'} </div>}
                </Button>
                :
                <Button style={{ border: "0px", backgroundColor: "rgb(135, 178, 178)", borderRadius: "15px" }} className='buttonAll py-2 px-3 mx-2  shadow text-light' type='submit' onClick={handleClose}>
                  {selectedLanguage === 'Marathi' ? 'अपडेट करा' : 'Update'} 
                </Button>
            }
          </Modal.Footer>
        </Modal>
      )}

      {showEdit && !show && ( // Check if 'showEdit' is true and 'show' is false
        <Modal show={showEdit} onHide={handleEditClose}>
          <Modal.Header className='m-0 p-0 ps-3 text-center' style={{ backgroundColor: "rgb(47, 79, 79)", color: "black" }}>
            <Modal.Title >
              <p style={{ fontSize: "18px" }} className='text-center mt-2 text-light'>{selectedLanguage === 'Marathi' ? 'उत्पादन मास्टर' : 'PRODUCT MASTER'}</p>
            </Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <Row className='m-0'>
              <Row className='mt-3' style={{ display: "flex" }}>
                <Col sm={5} md={5}>
                  <Form.Label><h6 >{selectedLanguage === 'Marathi' ? 'उत्पादनाचे नांव :' : 'Product Name :'}</h6></Form.Label>
                </Col>
                <Col sm={7} md={7}>
                  <Form.Control
                    aria-label="Default select example"
                    onChange={(e) => setProductName(e.target.value)}
                    value={productName}
                    required
                    maxLength={40}
                  >
                  </Form.Control>
                </Col>
              </Row>

              <Row sm={12} md={12} className='mt-3' style={{ display: "flex" }}>
  <Col sm={4} md={4}>
    <Form.Label><h6>{selectedLanguage === 'Marathi' ? 'स्थिती' : 'Status'} :</h6></Form.Label>
  </Col>
  <Col sm={8} md={8}>
  <FormGroup>
      <Stack direction="row" spacing={1} alignItems="center">
        <Typography>{selectedLanguage === 'Marathi' ? 'बंद' : 'Off'}</Typography>
        <AntSwitch
          checked={status}
          onChange={handleSwitchChange}
          inputProps={{ 'aria-label': 'ant design' }}
        />
        <Typography>{selectedLanguage === 'Marathi' ? 'चालू' : 'On'}</Typography>
      </Stack>
    </FormGroup>
  </Col>
</Row>

<Row className='mt-3' style={{ display: "flex" }}>
           
           <Col sm={4} md={5}>
             <Form.Label><h6 ><b>{selectedLanguage === 'Marathi' ? 'दर' : 'Rate'}:</b></h6></Form.Label>
             </Col>
             <Col sm={8} md={7}>
             <TextField
               size="small"
               style={{ width: '100%' }}
               type="number"
               pattern="[0-9]"
               required
               value={rate}
               onChange={(e) => setRate(e.target.value)}
             />
           </Col>
         </Row>

            </Row>
            <Form
            //  onSubmit={savedata}
              encType="multipart/form-data">


            </Form>
          </Modal.Body>

          <Modal.Footer className='m-0 p-0' style={{ backgroundColor: "rgb(47, 79, 79)" }}>
            <Button style={{ color: "black", backgroundColor: "white", border: "0px", borderRadius: "15px" }} onClick={handleEditClose}>
              {selectedLanguage === 'Marathi' ? 'रद्द करा' : 'Cancel'} 
            </Button>

            <Button style={{ border: "0px", backgroundColor: "rgb(135, 178, 178)", borderRadius: "15px" }} className='buttonAll py-2 px-3 mx-2  shadow text-dark' onClick={() => updateProduct(productId, productName,rate, status)}>
              {selectedLanguage === 'Marathi' ? 'अपडेट करा' : 'Update'} 
            </Button>
          </Modal.Footer>
        </Modal>
      )}
            {/* ============= Delete Modal ========= */}

            <Modal show={show1} onHide={handleClose1}>
        <Modal.Header style={{backgroundColor:"rgb(47, 79, 79)",color:"white"}} >
          <Modal.Title><i className="fa-solid fa-trash" style={{ color: "rgb(254, 105, 129)" }}></i> {selectedLanguage === 'Marathi' ? 'पुष्टीकरण हटवा' : 'Delete Confirmation'} </Modal.Title>
        </Modal.Header>
        <Modal.Body >{selectedLanguage === 'Marathi' ? 'तुमची खात्री आहे की तुम्ही हा आयटम हटवू इच्छिता?' : 'Are you sure you want to delete this item?'} </Modal.Body>
          <p className='text-end'>
          <Button className='mx-2' style={{color:"black",backgroundColor:"white",border:"2px solid rgb(135, 178, 178)",borderRadius:"15px"}}  onClick={handleClose1}>
            {selectedLanguage === 'Marathi' ? 'रद्द करा' : 'Cancel'} 
          </Button>
          <Button  style={{border:"opx",backgroundColor:"rgb(135, 178, 178)" ,borderRadius:"15px"}} className='buttonAll py-2 px-3 mx-2  shadow text-dark' onClick={() => onDelete(itemToDelete)}>
           {selectedLanguage === 'Marathi' ? 'हटवा' : ' Delete'} 
          </Button></p>
      </Modal>
</Row>






    </section>
    </div>
  )
}

export default ProductMaster1
